import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ProgressButton from 'react-progress-button';
import { Image } from '@components/common';
import { StripeService } from '@services';
import { STRIPE_KEY } from '@config';
import utils from '@utils';
import CreditCardForm from '../../../components/AddPaymentMethodModal/CreditCardForm/CreditCardForm';
import { QuickPaySummary } from './components';
import BankAccountForm from '../../../components/AddPaymentMethodModal/BankAccountForm';

class PaymentInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			creditCardFormRef : null,
			payByCard         : true,
			bankForm          : {
				bankHolderName         : { value : '', validation : null },
				routingNo              : { value : '', validation : null },
				accountNo              : { value : '', validation : null },
				// eslint-disable-next-line camelcase
				accountNo_confirmation : { value : '', validation : null },
				accountType            : { value : '', validation : null },
			},

		};
	}

	submitCCForm = (response) => {
		const { onSubmit } = this.props;
		onSubmit(response);
	}

	setCustomRef = (ref) => {
		this.setState({ creditCardFormRef : ref });
	}

	onSubmitClick = async () => {
		const { payByCard, creditCardFormRef, bankForm : { ...bankForm } } = this.state;
		const { updateProgressButton, onSubmit } = this.props;
		if (payByCard) {
			if (creditCardFormRef) creditCardFormRef.click();
		} else {
			// Validate the inputs
			bankForm.bankHolderName.validation = bankForm.bankHolderName.value.trim() === '' ? 'error' : null;
			bankForm.routingNo.validation = bankForm.routingNo.value.trim() === '' ? 'error' : null;
			bankForm.accountNo.validation = bankForm.accountNo.value.trim() === '' ? 'error' : null;
			bankForm.accountNo_confirmation.validation = bankForm.accountNo_confirmation.value.trim() === ''
			|| bankForm.accountNo_confirmation.value.trim() !== bankForm.accountNo.value.trim() ? 'error' : null;
			bankForm.accountType.validation = [1, 2].includes(bankForm.accountType.value) ? null : 'error';
			this.setState({ bankForm });
			// // Check if there are any invalid before proceeding
			if (Object.values(bankForm).some(({ validation }) => validation !== null)) {
				updateProgressButton('error');
				if (bankForm.accountNo_confirmation.validation === 'error') {
					utils.notify({ type : 'error', message : 'Entered account numbers do not match', timeOut : 1500 });
				}
			} else {
				updateProgressButton('loading');
				const form = Object.fromEntries(Object.entries(bankForm).map(([key, { value }]) => [key, value]));
				const token = await StripeService.createBankAccountToken(STRIPE_KEY, form);
				if (token.error) {
					updateProgressButton('error');
					utils.notify({
						type    : 'error',
						message : token.error.message || 'Error processing payment',
						timeOut : 2500,
					});
				} else {
					onSubmit({ token });
				}
			}
		}
	}

	onChangeBankForm = (property) => (event) => {
		let cleanValue = '';
		switch (property) {
			case 'bankHolderName':
				cleanValue = event.target.value;
				break;
			case 'accountType':
				cleanValue = event.value;
				break;
			default:
				// Clear all non-numeric characters from the value if it's not the account holder name or accountType
				cleanValue = event.target.value.replace(/[^0-9]/gi, '');
				break;
		}
		this.setState((prevState) => ({ bankForm : { ...prevState.bankForm, [property] : { value : cleanValue, validation : null } } }));
	}

	render() {
		const { payByCard, bankForm } = this.state;
		const {
			invoice, timeZoneId, buttonState, type, onReturn, updateProgressButton,
		} = this.props;

		const {
			TransactionSummaryItems = [],
			TotalOfficerPay,
			TotalJurisdictionFee,
			TotalOrganizationFee,
			RKPayFee,
			Tax,
			Total,
		} = invoice;

		return (
			<Fragment>
				<div className="container margin-top-30">
					<div className="row">
						<div className="col-sm-12 col-md-7">
							<div className="quickpay-payment-info">
								<ul className="nav nav-tabs">
									<li role="presentation" className={payByCard ? 'active' : ''}>
										<button type="button" className="btn btn-link padding-bottom-5" onClick={() => this.setState({ payByCard : true })}>
											Credit Card
										</button>
									</li>
									<li role="presentation" className={payByCard ? '' : 'active'}>
										<button type="button" className="btn btn-link padding-bottom-5" onClick={() => this.setState({ payByCard : false })}>
											ACH
										</button>
									</li>
								</ul>
								<Choose>
									<When condition={payByCard}>
										<div className="flex flex-align-items-center">
											<Image className="height-22 margin-right-5" src="/images/cardIcons/mastercard.png" />
											<Image className="height-22 margin-right-5" src="/images/cardIcons/visa.png" />
											<Image className="height-22" src="/images/cardIcons/amex.png" />
										</div>
										<div className="margin-top-10 margin-bottom-20">
											<span className="color-gray-shuttle">
												RollKall securely processes your payments. We accept Visa, MasterCard, American Express, and Discover.
											</span>
										</div>
										<CreditCardForm
											expandAddress
											setCustomRef={this.setCustomRef}
											onSubmit={this.submitCCForm}
											hideButtons
											onError={updateProgressButton}
										/>
									</When>
									<Otherwise>
										<BankAccountForm form={bankForm} onChange={this.onChangeBankForm} />
									</Otherwise>
								</Choose>
							</div>

							<div className="hidden-sm hidden-xs">
								<div className="flex flex-align-items-center flex-justify-content-space-between margin-top-30 margin-bottom-30">
									<div>
										<button
											type="button"
											className="btn btn-link margin-right-20 width-150"
											onClick={() => onReturn(1)}
										>
											<i className="rkf rkf-arrow-left margin-right-5" />
											<span>Back to Invoice Info</span>
										</button>
									</div>

									<div>
										<ProgressButton
											className="btn btn-primary width-150"
											state={buttonState}
											onClick={this.onSubmitClick}

										>
											<span>Continue</span>
											<i className="rkf rkf-arrow-right margin-left-5" />
										</ProgressButton>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-12 col-md-4 col-md-offset-1">
							<Choose>
								<When condition={type === '1'}>
									<QuickPaySummary
										invoice={invoice}
										timeZoneId={timeZoneId}
										type={type}
										status="unpaid"
									/>
								</When>
								<When condition={type === 'bulk'}>
									<QuickPaySummary
										invoice={{
											Items                 : TransactionSummaryItems,
											JurisdictionFees      : TransactionSummaryItems,
											TotalServiceCharge    : RKPayFee,
											TotalJurisdictionFees : TotalJurisdictionFee,
											TotalCoordinatorFee   : TotalOrganizationFee,
											TotalInvoice          : Total,
											TotalOfficerPay,
											Tax,
										}}
										timeZoneId={timeZoneId}
										type={type}
										status="unpaid"
									/>
								</When>
							</Choose>
						</div>
					</div>
				</div>

				<div className="container margin-top-30 margin-bottom-50 visible-sm-block visible-xs-block">
					<div className="flex flex-align-items-center flex-justify-content-space-between">
						<div>
							<button
								type="button"
								className="btn btn-link margin-right-20 width-150"
								onClick={() => onReturn(1)}
							>
								<i className="rkf rkf-arrow-left margin-right-5" />
								<span>Back to Invoice Info</span>
							</button>
						</div>

						<div>
							<ProgressButton
								className="btn btn-primary width-150"
								state={buttonState}
								onClick={this.onSubmitClick}

							>
								<span>Continue</span>
								<i className="rkf rkf-arrow-right margin-left-5" />
							</ProgressButton>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

PaymentInfo.propTypes = {
	buttonState          : PropTypes.string,
	invoice              : PropTypes.object,
	onReturn             : PropTypes.func.isRequired,
	onSubmit             : PropTypes.func.isRequired,
	timeZoneId           : PropTypes.string,
	type                 : PropTypes.string,
	updateProgressButton : PropTypes.func.isRequired,
};

PaymentInfo.defaultProps = {
	buttonState : '',
	invoice     : {},
	timeZoneId  : '',
	type        : '',
};

export default PaymentInfo;
